"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const table_1 = require("../../table");
const pageSelector_1 = require("./pageSelector");
const row_1 = require("./row");
const spinner_1 = require("../../spinner");
const drillDowns_1 = require("../simpleGrid/drillDowns");
function pageItems(items, selectedPage, selectedSize) {
    return items.slice(selectedPage * selectedSize, (selectedPage + 1) * selectedSize);
}
class GridTable extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.onDrillDown = (column, path) => {
            const newValue = drillDowns_1.addDrilldown(column, path, this.props.value);
            this.props.onChange(newValue);
        };
    }
    render() {
        const props = this.props;
        const { selectedPage, selectedSize, pageCount, itemsCount, minPageSize } = pageSelector_1.getPageValues(props.items.length, props.value.paginacion);
        const pageStart = selectedPage * selectedSize;
        const pagedItems = pageItems(props.items, selectedPage, selectedSize);
        const tableItems = pagedItems.map((x, i) => React.createElement(row_1.GridRow, { key: props.getKey ? props.getKey(x) : i, columns: props.columns, sharedValue: props.sharedData, value: x, onDrillDown: this.onDrillDown }));
        return (React.createElement("div", null,
            (itemsCount > minPageSize) &&
                React.createElement(pageSelector_1.PaginatorSelector, { itemsCount: props.items.length, value: props.value.paginacion, onChange: paginacion => props.onChange(Object.assign({}, this.props.value, { paginacion })) }),
            props.loading && React.createElement(spinner_1.Spinner, null),
            React.createElement(table_1.Table, { header: props.header, items: tableItems, overflow: this.props.overflow })));
    }
}
exports.GridTable = GridTable;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/table.js
// module id = 2227
// module chunks = 0